<template>
    <div class="design">
        <div>
            <!-- SIDEBAR DESIGN TEMPLATES
            <sidebar-design></sidebar-design> -->
            
            <!-- PICK TYPE SIDEBAR DESIGN -->
            <sidebar-pick-type v-if="sidebarType===''" v-on:sidebarClick="sidebarTypeChoosen"></sidebar-pick-type>
            <!-- SIDEBAR FULL -->
            <sidebar-full v-if="sidebarType==='full'" v-on:sidebarClick="sidebarTypeChoosen" ></sidebar-full>
            <!-- SIDEBAR TILED -->
            <sidebar-tiled v-if="sidebarType==='tiled'" v-on:sidebarClick="sidebarTypeChoosen" ></sidebar-tiled>
            <!-- SIDEBAR BORDER -->
            <sidebar-border v-if="sidebarType==='border'" v-on:sidebarClick="sidebarTypeChoosen" ></sidebar-border>
            <!-- SIDEBAR BANNER -->
            <sidebar-banner v-if="sidebarType==='banner'" v-on:sidebarClick="sidebarTypeChoosen" ></sidebar-banner>

            <div class="design-body uk-container-expand">
                <!-- QUICK OPTIONS - SUBNAV -->
                <div uk-sticky="animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky;" class="uk-animation-slide-top-small">
                    <nav class="uk-navbar-container uk-navbar-item body-navbar" uk-navbar>
                        <div class="uk-navbar-left uk-text-muted">Add Item</div>
                        <div v-if="sidebarType==='full' || sidebarType===''" v-on:click="sidebarTypeChoosen('full')" class="uk-overflow-auto scroller" style="z-index: 1; margin: auto;">
                            <ul class="uk-navbar-nav">
                                <a @click="addText" class="uk-link-text iconspace" uk-tooltip="title: Add Text; pos: bottom; delay: 400;"><i class="material-icons">text_fields</i></a>
                                <!-- calls uploadMarkToCanvas which weas stolen from vue-base64-file-upload -->                            
                                <label for="file-upload" class="uk-link-text iconspace" uk-tooltip="title: Add Image; pos: bottom; delay: 400;">
                                    <i class="material-icons">add_photo_alternate</i>
                                    <input id="file-upload" type="file" accept="image/*" @change="uploadMarkToCanvas"/>
                                </label>                            
                                <a @click="addRect" class="uk-link-text iconspace" uk-tooltip="title: Add Rectangle; pos: bottom; delay: 400;"><i class="material-icons">check_box_outline_blank</i></a>

                                <li class="divider"></li>
                                <!-- need to refresh slider to get div width using @click="show" -->
                                <a class="uk-link-text iconspace" uk-tooltip="title: Fill Color; pos: bottom; delay: 400;"><i class="material-icons">format_color_fill</i></a>
                                    <div uk-drop="mode: click">                                    
                                        <sketch-picker v-model="colorFill"/>
                                    </div>                          
                                <a class="uk-link-text iconspace" uk-tooltip="title: Border Color &amp; Width; pos: bottom; delay: 400;"><i class="material-icons">border_color</i></a>
                                    <div uk-drop="mode: click">                                    
                                        <sketch-picker v-model="colorBorder"/>
                                        <form class="object-edit-card">
                                            <label class="uk-form-label uk-text-small uk-text-bold">Border Width: {{ borderWidth }}</label>
                                            <input class="uk-range" type="range" min="0" max="10" step="0.2" v-model.number="borderWidth" style="width:220px"/>
                                        </form>
                                    </div>

                                <a class="uk-link-text iconspace" @click="deleteItem" uk-tooltip="title: Delete Item; pos: bottom; delay: 400;"><i class="material-icons">delete</i></a>                                
                                <li class="divider"></li>
                                <a class="uk-link-text iconspace" @click="verticalAlign" uk-tooltip="title: Vertical Align; pos: bottom; delay: 400;"><i class="material-icons">vertical_align_center</i></a>
                                <a class="uk-link-text iconspace" @click="horizontalAlign" uk-tooltip="title: Horizontal Align; pos: bottom; delay: 400;"><i class="material-icons" style="transform: rotate(90deg);">vertical_align_center</i></a>                            
                                <a class="uk-link-text iconspace" @click="toTop" uk-tooltip="title: Vertical Align Top; pos: bottom; delay: 400;"><i class="material-icons">vertical_align_top</i></a>
                                <a class="uk-link-text iconspace" @click="toBottom" uk-tooltip="title: Vertical Align Bottom; pos: bottom; delay: 400;"><i class="material-icons">vertical_align_bottom</i></a>
                            </ul>
                        </div>
                        <div v-else class="uk-overflow-auto scroller" style="z-index: 1; margin: auto;"></div>
                        <div class="uk-navbar-right uk-margin-left">
                            <ul class="uk-navbar-nav">
                            <li>
                                <button id="designSaveButton" class="uk-button uk-button-primary" v-on:click="openSaveDialogue"><b>Save</b></button>
                            </li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <!-- ASPECT RATIOS -->
                <div id="aspectRatios" v-if="(['full', 'tiled', 'banner', '', null].indexOf(sidebarType) >= 0)" class="uk-flex uk-flex-center uk-text-muted">
                    <a @click="aspectToggle('16_9')" class="uk-link-text"><div class="aspect_ratios">
                        <i class="material-icons" style="font-size: 32px;">crop_16_9</i>
                        <p class="uk-margin-remove uk-padding-remove uk-text-center" style="font-size: 10px;">16:9</p>
                    </div></a>
                    <a @click="aspectToggle('4_5')" class="uk-link-text"><div class="aspect_ratios uk-margin-left">
                        <i class="material-icons" style="font-size: 32px;  transform: rotate(90deg);">crop_5_4</i>
                        <p class="uk-margin-remove uk-padding-remove uk-text-center" style="font-size: 10px;">4:5</p>
                    </div></a>
                    <a @click="aspectToggle('1_1')" class="uk-link-text"><div class="aspect_ratios uk-margin-left">
                        <i class="material-icons" style="font-size: 32px;">crop_square</i>
                        <p class="uk-margin-remove uk-padding-remove uk-text-center" style="font-size: 10px;">1:1</p>
                    </div></a>
                </div>
                <div v-else style="margin-top: 95px;">
                </div>
                <!-- CANVAS ELEMENT -->
                <div id="cwrap" :class="[{'cwrap_16_9': currentAspectRatio === '16_9', 'cwrap_4_5': currentAspectRatio === '4_5', 'cwrap_1_1': currentAspectRatio === '1_1'}]">
                    <!-- TEXT TOOLS -->
                    <div id="toggle-textbox-tools" ref="toggleTextboxTools" class="text-tools" hidden>
                        <span class="uk-text-small" style="float:left; margin-top:-22px; font-family: Poppins">Quick Options:</span>
                        
                        <div class="uk-flex uk-flex-center">
                            <a class="uk-link-text"><div class="text-controls">
                                <i class="material-icons" style="font-size: 20px;">title</i>
                                <span><i class="material-icons" uk-tooltip="title: Text Shadow; pos: bottom; delay: 400;" style="font-size: 20px; filter: blur(1px); position: absolute; margin-top: 4px; margin-left: -24px;">title</i></span>
                            </div></a>
                                <div uk-drop="mode: click" style="z-index: 999">    
                                    <div class="object-edit-card-2 uk-flex uk-flex-wrap"> 
                                        <div class="uk-width-1-1" style="border-bottom: 1px solid gainsboro; width: 100%; margin-bottom: 20px;">
                                            <label class="uk-width-expand uk-form-label">Shadow Position:</label>  
                                            <label class="uk-form-label uk-padding-remove uk-float-right"><a @click="removeTextShadow" class="wm-blue">RESET/REMOVE</a></label> 
                                        </div>   

                                        <div class="uk-inline uk-margin-remove uk-padding-remove checkered-small">
                                            <circle-slider v-model="textShadow360" :min="0" :max="360" :step-size="1" :progress-width="1" knob-color="#39f" progress-color="black" class="circle-slider"></circle-slider>  
                                            <div class="uk-position-center">
                                                <div style="font-size: 50px; margin-top: -5px; -webkit-text-stroke: 1px white;" :style="{'text-shadow': textShadowString}">A</div>
                                            </div>
                                        </div>                                        
                                        <div class="uk-margin-left uk-width-expand">
                                            <form class="uk-form-stacked">
                                                <label class="uk-form-label uk-text-small uk-text-bold">Distance: {{ textShadowDistance }}</label> 
                                                <input class="uk-range" type="range" min="0" max="20" step="1" v-model.number="textShadowDistance" style="width:160px"/>   
                                                <label class="uk-form-label uk-text-small uk-text-bold">Blur Amount: {{ textShadowBlur }}</label> 
                                                <input class="uk-range" type="range" min="0" max="15" step="1" v-model.number="textShadowBlur" style="width:160px"/>  
                                            </form>                                  
                                        </div>                                           
                                        <div class="uk-width-1-1 uk-margin-small-top" style="border-bottom: 1px solid gainsboro; width: 100%; margin-bottom: 10px;">
                                            <label class="uk-form-label">Shadow Color:</label>
                                            </div>
                                            <grayscale-picker class="uk-padding-remove" v-model="textShadowColor"/>                               
                                        
                                    </div>
                                </div>                         
                            <a class="uk-link-text"><div class="text-controls uk-margin-left">
                                <i class="material-icons" uk-tooltip="title: Text Color; pos: bottom; delay: 400;" style="font-size: 20px;">format_color_fill</i></div>
                            </a>  
                                <div uk-drop="mode: click" style="z-index: 999">                                    
                                    <sketch-picker v-model="colorFill"/>
                                </div> 
                                <a class="uk-link-text"><div class="text-controls uk-margin-left">
                                <i class="material-icons" uk-tooltip="title: Text Outline; pos: bottom; delay: 400;" style="font-size: 20px;">border_color</i></div>
                            </a>  
                                <div uk-drop="mode: click" style="z-index: 999">                                    
                                    <sketch-picker v-model="colorBorder"/>
                                    <form class="object-edit-card">
                                        <label class="uk-form-label uk-text-small uk-text-bold">Border Width: {{ borderWidth }}</label>
                                        <input class="uk-range" type="range" min="0" max="10" step="0.2" v-model.number="borderWidth" style="width:220px"/>
                                    </form>
                                </div>                         
                            <a @click="addCopyright" class="uk-link-text"><div class="text-controls uk-margin-left">
                                <i class="material-icons" style="font-size: 20px;">copyright</i>
                            </div></a>
                            
                            <!-- font-picker applies font-family to any object with apply-font class.. i'm binding font-family to css style for this div to pick up change and apply it to selected canvas object -->
                            <div id="font-picker"></div>  
                            <div class="apply-font"></div> 
                            <div class="divider-text-tools"></div> 
                            <div class="uk-width-1-3" style="margin-top: 5px; padding: 0 15px 0 5px;">                                
                                <div class="uk-grid">
                                    <label class="uk-width-expand uk-form-label"><b>Opacity:</b></label>
                                    <label class="uk-form-label uk-padding-remove">{{opacityVueSliderText}}%</label>
                                </div>                                
                                <vue-slider ref="vueSliderOpacity2" v-model="opacityVueSliderText" :tooltip="'none'"></vue-slider>
                            </div>                  
                        </div>
                        
                    </div>
                    <!-- TOGGLE IMAGE TOOLS -->
                    <div id="toggle-image-tools" ref="toggleImageTools" class="image-tools" hidden>
                        <div class="uk-flex uk-flex-center">
                            <span class="uk-text-small " style="position: absolute; margin-top:-22px">Image Options:</span>
                            <a class="uk-link-text"><div class="text-controls">
                                <i class="material-icons" style="font-size: 20px;">title</i>
                                <span><i class="material-icons" uk-tooltip="title: Text Shadow; pos: bottom; delay: 400;" style="font-size: 20px; filter: blur(1px); position: absolute; margin-top: 4px; margin-left: -24px;">title</i></span>
                            </div></a>
                                <div uk-drop="mode: click" style="z-index: 999">    
                                    <div class="object-edit-card-2 uk-grid">                                
                                        <div class="uk-inline uk-margin-remove uk-padding-remove checkered-small">
                                            <circle-slider v-model="textShadow360" :min="0" :max="360" :step-size="1" :progress-width="1" knob-color="#39f" progress-color="black" class="circle-slider"></circle-slider>  
                                            <div class="uk-position-center">
                                                <div style="font-size: 50px; margin-top: -5px; -webkit-text-stroke: 1px white;" :style="{'text-shadow': textShadowString}">A</div>
                                            </div>
                                        </div>
                                        <div>
                                            <form class="uk-form-stacked">
                                                <label class="uk-form-label uk-text-small uk-text-bold">Distance: {{ textShadowDistance }}</label> 
                                                <input class="uk-range" type="range" min="0" max="20" step="1" v-model.number="textShadowDistance" style="width:160px"/>   
                                                <label class="uk-form-label uk-text-small uk-text-bold">Blur Amount: {{ textShadowBlur }}</label> 
                                                <input class="uk-range" type="range" min="0" max="15" step="1" v-model.number="textShadowBlur" style="width:160px"/>  
                                            </form>                                  
                                        </div>   
                                        <a class="uk-link-text uk-text-muted iconspace" style="position:absolute; bottom: -8px; left: -8px;" uk-tooltip="title: Shadow Fill Color; pos: bottom; delay: 400;"><i class="material-icons" style="font-size: 18px;">format_color_fill</i></a>
                                            <div uk-drop="mode: click" style="z-index: 999">                                    
                                                <sketch-picker v-model="textShadowColor"/>
                                            </div>
                                        <a class="uk-link-text" @click="removeTextShadow" style="position:absolute; top: -15px; right: -20px;">reset</a>
                                    </div>
                                </div> 
                            <div class="divider-text-tools"></div>
                            <form class="uk-form-stacked" style="width: 200px; margin-top: 6px;">
                                <div class="uk-grid">
                                    <label class="uk-width-expand uk-form-label uk-margin-remove"><b>Opacity:</b></label>
                                    <label class="uk-form-label uk-padding-remove uk-margin-remove">{{opacityVueSlider}}%</label>
                                </div>                                
                                <vue-slider ref="vueSliderOpacity" v-model="opacityVueSlider" :tooltip="'none'"></vue-slider>

                            </form>              
                        </div>
                    </div>       
                    <!-- only show background image toggle for 16_9 ratio, too much petty logic to store and display backgrounds per aspect ratio -->
                    <div v-if="currentAspectRatio === '16_9'" class="canvas-background-selector uk-text-muted" style="font-size: 12px"><i>Sample background:</i> <br>
                        <a class="uk-icon uk-icon-image" @click="canvasBackgroundUrl('url(/img/illustrations/backgrounds/design/wedding_16_9.jpg)')" style="background-image: url(/img/illustrations/backgrounds/design/wedding_icon.jpg);"></a    >
                        <a class="uk-icon uk-icon-image" @click="canvasBackgroundUrl('url(/img/illustrations/backgrounds/design/house_16_9.jpg)')" style="background-image: url(/img/illustrations/backgrounds/design/house_icon.jpg);"></a>
                        <a class="uk-icon uk-icon-image" @click="canvasBackgroundUrl('url(/img/illustrations/backgrounds/design/parakeet_16_9.jpg)')" style="background-image: url(/img/illustrations/backgrounds/design/parakeet_icon.jpg);"></a>
                        <a class="uk-icon uk-icon-image" @click="canvasBackgroundUrl('url(/img/illustrations/backgrounds/design/landscape_16_9.jpg)')" style="background-image: url(/img/illustrations/backgrounds/design/landscape_icon.jpg);"></a>
                        <a uk-icon="icon: ban; ratio: 0.8" @click="canvasBackgroundUrl('checkered')"></a>
                    </div>
                    <canvas id="canvas" class="canvasexy checkered"></canvas>
                    <span class="uk-text uk-text-small uk-text-muted"><i>Hint: put browser in full screen for larger canvas</i></span>
                </div>

            </div>
            <!-- EXPORT OFF-CANVAS -->
            <div id="offcanvas-flip-2" uk-offcanvas="flip: true; overlay: true">
                <div class="uk-offcanvas-bar scroller">
                    <button class="uk-offcanvas-close" type="button" uk-close></button>
                    <form class="uk-form-stacked uk-margin-medium">
                        <legend class="uk-legend">Save Watermark &nbsp;<span uk-icon="icon: cloud-upload; ratio: 1.5"></span></legend>
                        <hr>
                        <!-- ACCORDIAN -->
                        <ul uk-accordion="multiple: true">
                            <li class="uk-open">
                            <a class="uk-accordion-title uk-text-muted" href="#">Your Mark</a>
                            <div class="uk-accordion-content">
                                <p>This watermark will be saved to My Marks and can be used in the Apply mode. </p>
                            </div>
                            <hr>
                            <label class="uk-form-label uk-text-muted" for="form-stacked-text">Descriptive Name:</label>                  
                                <div class="uk-form-controls">
                                    <input :class="['uk-input uk-form-small', {'highlight-red': highlightRed}]" ref="fileNameTextBox" autocomplete="off" v-model="markName" type="text" placeholder="Name...">
                                </div>
                            </li>
                        </ul>                        
                        <button v-if="isSaving" @click.prevent="saveSVG" class="uk-button uk-button-danger uk-margin uk-width-1-1" style="border-radius: 2px;"><b>Saving </b> <span uk-spinner="ratio: 0.6"></span></button>
                        <button v-else @click.prevent="saveSVG" class="uk-button uk-button-danger uk-margin uk-width-1-1" style="border-radius: 2px;"><b>Save</b></button>
                        <p class="uk-margin-remove uk-padding-remove uk-text-small uk-text-muted uk-text-center">
                            <i>Save to My Marks</i>
                            <br><br>
                            <i style="font-size: 10px">(background images will not be saved with your watermark!)</i>
                        </p>
                    </form>
                </div>
            </div>
        </div>            
    </div>
</template>

<script>
    import Vue from 'vue'

    // Load components
    import SidebarDesign from './sidebar/SidebarDesign.vue'
    import SidebarFull from './sidebar/SidebarFull.vue'
    import SidebarTiled from './sidebar/SidebarTiled.vue'
    import SidebarBorder from './sidebar/SidebarBorder.vue'
    import SidebarBanner from './sidebar/SidebarBanner.vue'
    import SidebarPickType from './sidebar/SidebarPickType.vue' 

    // Import NPM Packages
    import { Sketch } from 'vue-color'
    import { Grayscale } from 'vue-color'
    import { FontPicker } from 'font-picker'
    import UIkit from 'uikit'
    import FastAverageColor from 'fast-average-color/dist/index.es6'    
    import firebase from 'firebase/app'
    
    // Import JS Helpers
    import {fit} from '../../assets/js/fitters/fit.js'
    import '../../assets/js/fabricExtensions.js'

    // variables
    var resizeHistory = [];    
    var dataUri = null

    // functions
    function toRadians (angle) {
        return angle * (Math.PI / 180);
    }

    function letterCounter (x) {
        return x.replace(/[^a-zA-Z]/g, '').length;
    }  

    export default {
        name: 'Design',
        components: {
            'sidebar-design': SidebarDesign,
            'sidebar-full': SidebarFull,
            'sidebar-tiled': SidebarTiled,
            'sidebar-border': SidebarBorder,
            'sidebar-banner': SidebarBanner,
            'sidebar-pick-type': SidebarPickType,
            'sketch-picker': Sketch,
            'grayscale-picker': Grayscale
        },
        data() {
            return {
                isSaving: false,
                canvasWidth: 0,
                canvasHeight: 0,
                colorFill: '#f4c20d',
                colorBorder: '#000',
                borderWidth: 0,     
                fontFamily: 'Times New Roman',
                fullFontList: [],                
                opentypeFont: {},
                textShadow360:35,
                textShadow: {color: '#000000', blur: 10, offsetX: 0, offsetY: 5, opacity: 1},
                textShadowDistance: 5,
                textShadowBlur: 10,
                textShadowColor: 'black',
                textShadowString: '0px 5px 10px black',
                customImageMaxSize: 2,
                dataUri: "",
                imageOpacity: 100,
                sidebarType: '',
                opacityVueSlider: 100,
                opacityVueSliderText: 100, 
                markName: null,
                highlightRed: false,
                currentAspectRatio: '16_9',
                watermarkType: 'full',
                // Apply Pattern
                patternSourceCanvas: null,
                patternFabric: null,
                patternScaleToWidth: 100,
                patternAngle: 0,
                patternOffsetX: 0,
                patternOffsetY: 0,
                patternPadding: 0, 
                patternOpacity: 100,
                markForTile: '',
                // Apply Border
                borderOpacity: '',
                borderColor: {hex: '#ffffff'},
                borderType: '',
                borderSizeSlider: { value: ["S","S"], width: "95%", tooltip: "false", disabled: false, piecewise: true, piecewiseLabel: true, tooltipDir: "bottom", style: { "marginLeft": "1%" }, fixed: true, data: [ "XS", "S", "M", "L", "XL", ], piecewiseStyle: { "backgroundColor": "#c0c0c0", "visibility": "visible", "height": "6px", "width": "6px" }, piecewiseActiveStyle: { "backgroundColor": "#3498db" }, labelActiveStyle: { "color": "#3498db", "fontWeight": "bold" } },
                borderFontSizeSlider: { value: 20, min: 6, max: 100, tooltip: "false" },
                borderOpacitySlider: 100,
                borderTextTop: null,
                borderTextBottom: null,
                borderTextPosition: null               
            }
        },
        computed: {
            imageOpacity100: function () {
                return Math.round(this.opacityVueSlider * 1)
            },           
        },
        mounted() {
            // adding component vm globally so font-picker can write to fontFamily for textbox on canvas
            // custom code added to font-picker: ./node_modules/font-picker/lib/font-picker.js
            global.vmDesign = this;              
            var me;
            me = this;

            // Ask if user wants to Start Tour            
            // need to wait for designTour to mount in App.vue
            setTimeout(function(){
                if (me.globalMarks.savedMarks.length < 1) {                                        
                    me.$parent.startDesignTour();
                }                
            }, 500);
            

            // Google Fonts            
            let fontPicker = new FontPicker(
                'AIzaSyDK65JWYanH8gf3UOpXtYXPOzVNlwmc0vw', // Google API key
                'Open Sans', // default font
                {limit: 120},
                setCanvasFont
            );         

            
            function setCanvasFont() {
                setTimeout(function(){
                    let activeFont = fontPicker.getActiveFont().family
                    me.fontFamily = activeFont
                    me.canvasObj.getActiveObject().set("fontFamily", me.fontFamily);
                    me.canvasObj.renderAll();                    
                }, 200);            
            }
            

            //
            // CANVAS
            //

            // Instantiate Canvas
            var canvas = document.getElementById("canvas");
            this.canvasObj = new fabric.Canvas("canvas", {preserveObjectStacking: true});
           
            // Make Canvas Fabric Pretty
            fabric.Object.prototype.set({
                transparentCorners: false,
                borderColor: 'rgba(77, 139, 255, 0.66)',
                cornerColor: 'rgba(77, 139, 255, 0.66)',
                cornerStyle: 'circle',
                cornerSize: 15,
                padding: 0,
            });

            // Keyboard Events
            const self = this
             document.onkeydown = function(e) {
                switch (e.keyCode) {
                case 38:  /* Up arrow */
                    if(self.canvasObj.getActiveObject()){
                        self.canvasObj.getActiveObject().top -= 5;
                        self.canvasObj.renderAll();
                    }
                    break;
                case 40:  /* Down arrow  */
                    if(self.canvasObj.getActiveObject()){
                        self.canvasObj.getActiveObject().top += 5;
                        self.canvasObj.renderAll(); 
                    }
                    break;
                case 37:  /* Left arrow  */
                    if(self.canvasObj.getActiveObject()){
                        self.canvasObj.getActiveObject().left -= 5; 
                        self.canvasObj.renderAll();
                    }
                    break;
                case 39:  /* Right arrow  */
                    if(self.canvasObj.getActiveObject()){
                        self.canvasObj.getActiveObject().left += 5; 
                        self.canvasObj.renderAll();
                    }
                    break;
                case 46:  /* delete */
                    let delObj = self.canvasObj.getActiveObject();
                    if(delObj){
                        self.canvasObj.remove(delObj); 
                    }
                    
                    /* If you want to remove more than one at a time,
                    but this adds signficant amount of checking before 
                    var canvasObjects = self.canvasObj.getObjects();
                    while(canvasObjects.length != 0 ){
                        self.canvasObj.remove(canvasObjects[0]);
                    self.canvasObj.discardActiveObject();
                    } */
                    
                    break;

                }
             }

            // Snap Rotate
            this.canvasObj.on('object:rotating', function(options) {
                if(options.e.shiftKey) {
                    options.target.snapAngle = 0;
                } else {
                    options.target.snapAngle = 15;
                }
            });
            
            // Enforce Canvas Boundary
            this.canvasObj.on('object:moving', function(e) {
                var obj = e.target;
                // if object is too big ignore
                if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
                    return;
                }
                obj.setCoords();
                // top-left  corner
                if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
                    obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
                    obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
                }
                // bot-right corner
                if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width) {
                    obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top);
                    obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left);
                }
            });
            
            // Auto Scale 
            this.$nextTick(function() {
                window.addEventListener('resize', this.getCanvasWidth); // on resize, run getWindowWidth
                window.addEventListener('resize', this.getCanvasHeight);
                window.addEventListener('resize', this.canvasResize); // I SHOULD add window.removeEventListener('resize', thing) when i'm done!!

                //Init
                this.getCanvasWidth()
                this.getCanvasHeight()
                this.canvasResize()
            }); 

            var me;
            me = this;

            // toggle-textbox-tools: click textbox on canvas
            this.canvasObj.on('selection:created', function(options) {
                // TEXT
                if (options.target.get('type') === "i-text") {
                    // pop div up      
                    // UIkit.toggle(me.$refs.toggleImageTools).toggle();
                    UIkit.toggle({target: me.$refs.toggleTextboxTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                };

                // IMAGE
                if (options.target.get('type') === "image") {
                    // pop div up      
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                };       

                // SVG
                if (options.target.get('type') === "path") {
                    // pop div up      
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                }; 
            });             
            
            // toggle-textbox-tools: click to another textbox
            this.canvasObj.on('selection:updated', function(options) {
                // this whole section makes me want to cry
                // but between the different events you need to check from and what you're switching to
                
                var ttt = document.getElementById("toggle-textbox-tools")
                var tit = document.getElementById("toggle-image-tools")
                
                // if switch from one type to another of same type
                if (options.target.get('type') === "i-text" && ttt.hidden === false) {
                    // do nothing
                } else if (options.target.get('type') === "image" && tit.hidden === false) {
                    // do nothing
                }
                // if switch from one type to another type
                else if ((options.target.get('type') === "i-text" || options.target.get('type') === "path") && tit.hidden === false) {
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()  
                    UIkit.toggle({target: me.$refs.toggleTextboxTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                } else if (options.target.get('type') === "image" && ttt.hidden === false) {
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()  
                    UIkit.toggle({target: me.$refs.toggleTextboxTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                }
                // if switch from text or image to non-text or non-image type
                else if ((options.target.get('type') !== "image" || (options.target.get('type') === "i-text" || options.target.get('type') === "path")) && ttt.hidden === false) {
                    // remove div
                    UIkit.toggle({target: me.$refs.toggleTextboxTools, animation: 'uk-animation-slide-bottom-small'}).toggle()  
                } else if ((options.target.get('type') !== "image" || (options.target.get('type') === "i-text" || options.target.get('type') === "path")) && tit.hidden === false) {
                    // remove div
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()  
                }
                // if switch from non-text or non-image type to text or image type
                else if ((options.target.get('type') === "i-text" || options.target.get('type') === "path") && ttt.hidden === true) {
                    // remove div
                    UIkit.toggle({target: me.$refs.toggleTextboxTools, animation: 'uk-animation-slide-bottom-small'}).toggle()  
                } else if (options.target.get('type') === "image" && tit.hidden === true) {
                    // remove div
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()  
                }; 



            });   
            
            // toggle-textbox-tools: click away from textbox
            var canvasScoped = this.canvasObj
            this.canvasObj.on('before:selection:cleared', function(options) {
                if ((options.target.get('type') === "i-text" || options.target.get('type') === "path")) {
                    UIkit.toggle({target: me.$refs.toggleTextboxTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                };

                if (options.target.get('type') === "image") {
                    UIkit.toggle({target: me.$refs.toggleImageTools, animation: 'uk-animation-slide-bottom-small'}).toggle()
                };
            });   
            
            // when #toggle-image-tools fires (displays) I need to refresh the slider in order for it to render
            /* not needed with new vue-slider component update
            var me;
            var me = this;

            UIkit.util.on(me.$refs.toggleImageTools, 'show', function () {
                me.$refs.vueSliderOpacity.refresh()
            });

            UIkit.util.on(me.$refs.toggleTextboxTools, 'show', function () {
                me.$refs.vueSliderOpacity2.refresh()
            });   
            */
            
        }, 
        methods: {       
            // Auto Scale 
            getCanvasWidth(event) {
                if (this.$route.path == "/design" && document.getElementById('cwrap').offsetWidth) {
                    this.canvasWidth = document.getElementById('cwrap').offsetWidth
                }
            },

            getCanvasHeight(event) {
                if (this.$route.path == "/design" && document.getElementById('cwrap').offsetHeight) {
                    this.canvasHeight = document.getElementById('cwrap').offsetHeight
                }
            },
            canvasResize(event) {
                // resize canvas itself
                this.canvasObj.setDimensions({
                    width: this.canvasWidth,
                    height: this.canvasHeight
                })


                // Zoom Function - DEPRECATING BECAUSE IT'S UNRELIABLE FOR TILE / BORDER / ETC MODES
                /*
                // resizeHistory=[] declared above vue instance
                if (resizeHistory.length >= 2) {
                    resizeHistory.shift(); // this removes previous dimensions ... only need latest two for scaleFactor
                }

                // store current and previous window size
                resizeHistory.push({canvasWidth: this.canvasWidth, canvasHeight: this.canvasHeight});

                // calculate scale factor 
                if (resizeHistory.length == 2) {                
                    var scaleFactor = resizeHistory[1].canvasWidth / resizeHistory[0].canvasWidth
                }

                let factor = scaleFactor; 
                if (this.canvasObj.backgroundImage) {
                    // Need to scale background images as well
                    var bi = canvas.backgroundImage;
                    bi.width = bi.width * factor;
                    bi.height = bi.height * factor;
                }
                var objects = this.canvasObj.getObjects();
                for (var i in objects) {
                    var scaleX = objects[i].scaleX;
                    var scaleY = objects[i].scaleY;
                    var left = objects[i].left;
                    var top = objects[i].top;

                    var tempScaleX = scaleX * factor;
                    var tempScaleY = scaleY * factor;
                    var tempLeft = left * factor;
                    var tempTop = top * factor;

                    objects[i].scaleX = tempScaleX;
                    objects[i].scaleY = tempScaleY;
                    objects[i].left = tempLeft;
                    objects[i].top = tempTop;

                    objects[i].setCoords();
                }
                this.canvasObj.renderAll();
                this.canvasObj.calcOffset();
                */
            
            },
            beforeDestroy() {
                window.removeEventListener('resize', this.getCanvasWidth);
                window.removeEventListener('resize', this.getCanvasHeight);
            },
            // Canvas Objects that are added to canvas element
            addRect() {
                let rect = new fabric.Rect({
                    left: 100,
                    top: 100,
                    width: 60,
                    height: 60,
                    fill: '#f4c20d',
                    originX: 'left',
                    originY: 'top',
                    centeredRotation: true,
                    // centeredScaling: true,
                    strokeWidth: 0,
                });
                this.canvasObj.add(rect);
            },
            openSaveDialogue() {
                UIkit.offcanvas('#offcanvas-flip-2').show();
            },
            // Save
            saveSVG() {

                var me;
                me = this;

                // (This does not need to be in mounted() or created() because DOM has already been
                // registered and by creating design and clicking "save" elements should already be loaded)

                // JSON without default values
                this.canvasObj.includeDefaultValues = false;

                // console.log(this.canvasObj.toSVG())
                var myJSON = this.canvasObj.toJSON();
                var mySVG = this.canvasObj.toSVG();
                var myPNG = this.canvasObj.toDataURL('image/png', 1);

                // require name
                if (this.markName === null || this.markName === '') {
                    this.highlightRed = true;
                    return
                } else {
                    this.highlightRed = false;
                }

                // enforce max length      
                if (letterCounter(this.markName) >= 30) {
                    UIkit.modal.alert('Name must be less than 30 characters.')
                    return
                } 

                // ensure there is something on canvas
                if (this.canvasObj.getObjects().length === 0) {
                    UIkit.modal.alert('<i class="material-icons uk-inline" style="color: #f4c20d; font-size: 48px;">warning</i> You must design a watermark before saving.')
                    return
                }

                //
                // Start Save
                // 

            
                this.isSaving = true;

                // save to global variable, globalMarks
                var today = new Date();
                if (this.watermarkType === 'full') {
                    this.globalMarks.savedMarks.push({
                        "name": this.markName,
                        "origHeight": document.getElementById('cwrap').offsetHeight,
                        "origWidth": document.getElementById('cwrap').offsetWidth,
                        "fontProperties": [], // array
                        "isLightOrDark": {"isDark": false,
                                        "isLight": false},
                        "json": myJSON, // object
                        "svg": mySVG, // string
                        "png": myPNG,
                        "favorite": false,
                        "watermarkType": this.watermarkType,
                        "createdOn": today.toISOString().substring(0, 10),
                        "documentId": null
                    });                    
                } else if (this.watermarkType === 'tiled') {
                    this.globalMarks.savedMarks.push({
                        "name": this.markName,
                        "origHeight": document.getElementById('cwrap').offsetHeight,
                        "origWidth": document.getElementById('cwrap').offsetWidth,
                        "fontProperties": [], // array
                        "isLightOrDark": {"isDark": false,
                                        "isLight": false},
                        "json": myJSON, // object
                        "svg": mySVG, // string
                        "png": myPNG,
                        "favorite": false,
                        "watermarkType": this.watermarkType,
                        "createdOn": today.toISOString().substring(0, 10),
                        "documentId": null,
                        "tiledProperties": {
                            markForTile: this.markForTile,
                            patternScaleToWidth: this.patternScaleToWidth,
                            patternAngle: this.patternAngle,
                            patternOffsetX: this.patternOffsetX,
                            patternOffsetY: this.patternOffsetY,
                            patternPadding: this.patternPadding,
                            patternOpacity: this.patternOpacity,
                        }
                    });                    
                } else if (this.watermarkType === 'border') {
                    this.globalMarks.savedMarks.push({
                        "name": this.markName,
                        "origHeight": document.getElementById('cwrap').offsetHeight,
                        "origWidth": document.getElementById('cwrap').offsetWidth,
                        "fontProperties": [], // array
                        "isLightOrDark": {"isDark": false,
                                        "isLight": false},
                        "json": myJSON, // object
                        "svg": mySVG, // string
                        "png": myPNG,
                        "favorite": false,
                        "watermarkType": this.watermarkType,
                        "createdOn": today.toISOString().substring(0, 10),
                        "documentId": null,
                        "borderProperties": {
                            borderOpacity: this.borderOpacity,
                            borderColor: this.borderColor.hex,
                            borderType: this.borderType,
                            borderSize: this.borderSize(),
                            borderFontSize: this.borderFontSizeSlider.value,
                            borderOpacity: this.borderOpacitySlider.value/100,
                            borderTextTop: this.borderTextTop,
                            borderTextBottom: this.borderTextBottom,
                            borderTextPosition: this.borderTextPosition,                        
                        }
                    });                    
                }


                const pos = this.globalMarks.savedMarks.length - 1
                
                // save list of fonts to object... application needs preloaded fonts to render
                for (let i = 0; i < myJSON.objects.length; i++) {
                    if (myJSON.objects[i].fontFamily) {
                        this.globalMarks.savedMarks[pos].fontProperties.push({
                            fontFamily: myJSON.objects[i].fontFamily, 
                            fontColor: myJSON.objects[i].fill,
                            fontSize: this.borderFontSizeSlider.value
                        })
                    }
                }

                // calculate if mark is light or dark for preview background rendering
                const fac = new FastAverageColor();
                const color = fac.getColor(document.getElementById('canvas'));

                if (color.isDark) {
                    this.globalMarks.savedMarks[pos].isLightOrDark.isDark = true;
                    this.globalMarks.savedMarks[pos].isLightOrDark.isLight = false;
                } else if (color.isLight) {
                    this.globalMarks.savedMarks[pos].isLightOrDark.isLight = true;
                    this.globalMarks.savedMarks[pos].isLightOrDark.isDark = false;
                } else {
                    this.globalMarks.savedMarks[pos].isLightOrDark.isLight = false;
                    this.globalMarks.savedMarks[pos].isLightOrDark.isDark = false;
                }
            
                // The instance is no longer needed.
                fac.destroy();

                // Get all fonts used in watermark.. they will be loaded on app started using webfontloader.js
                var objs = this.canvasObj.getObjects()
                for (let i = 0; i < objs.length; i++) {
                    if (objs[i].fontFamily) {
                        this.fullFontList.push(objs[i].fontFamily)
                    }
                }

                //
                // Firebase|Firestore
                // 

                /* k, so here's the skinny.. if a user is logged in, firebase is the source of record. I write straight to it
                and whenever sidetemplates loads (w/ user logged in), it erases all local marks and replaces with cloud marks
                ps. it already saves locally above but w.e... for logged in it'll just get erased when sidebar loads with cloud marks
                ... if user is not logged in... business as usual and its all local
                */

                // is user logged in + exclude anon accounts
                if (me.globalSessionInfo.currentUser.isLoggedIn) {

                    // Save mark to firebase                
                    let userId = firebase.auth().currentUser.uid;   
                    let wmRef = firebase.firestore().collection('watermarks').doc(userId).collection('marks');       
                    let storage = firebase.storage()
                    let docId
                    
                    async function firebaseSaveWM() {
                        let savedMarkTemp = me.globalMarks.savedMarks[pos]                         

                        // 1) Add watermark json to Firestore and get document reference                                                  
                        try {
                            const docRef = await wmRef.add(savedMarkTemp)
                            docRef.update({documentId: docRef.id})
                            me.globalMarks.savedMarks[pos].documentId = docRef.id;  
                            
                             console.log('here2')

                            // 2) Now that we have docRef, put png and svg in Firebase Storage
                            const putPNG = storage.ref('user/' + userId + '/watermarks/' + docRef.id + '.png').putString(myPNG, 'data_url')
                            const putSVG = storage.ref('user/' + userId + '/watermarks/' + docRef.id + '.svg').putString(myPNG) // fb only takes strings       

                            const uploadTasks = [putPNG, putSVG].map(task => {
                                return task
                            })     
                            const uploadTasksComplete = await Promise.all(uploadTasks) 
                            
                            // png
                            const url = await uploadTasksComplete[0].metadata.ref.getDownloadURL()
                            wmRef.doc(docRef.id).update({png: url})

                            // svg
                            const url2 = await uploadTasksComplete[1].metadata.ref.getDownloadURL()
                            wmRef.doc(docRef.id).update({svg: url2})

                            return me.saveSuccessful()                            
                        } catch(err) {
                            var desc = 'Issue saving watermark to cloud.'
                            return me.$parent.recordError(err, desc)
                        }                        
                    }
                    firebaseSaveWM() 
                } else { 
                    me.saveSuccessful()                   
                }
                
            }, 
            saveSuccessful() {

                // If successful, display success                
                let saveText = '<b>' + this.globalMarks.savedMarks[this.globalMarks.savedMarks.length - 1].name + '</b> added to <b>My Marks</b> in the Apply mode.'
                
                this.$notify({
                    title: '<span style="color: #68CD86">Successfully Saved!</span>',
                    text: saveText,
                    group: 'loaded',
                    type: 'info',
                    duration: 2000
                });            

                // Close sidebar
                // 
                // need to do a hard delete of the element because somehow vue + uikit 
                // keep making new instances of the offscreen instead of hiding and showing 
                // the current one
                // check that element exists because sometimes it doesn't (vue is annoying)
                try {
                    UIkit.offcanvas('#offcanvas-flip-2').hide().then(function () {UIkit.offcanvas('#offcanvas-flip-2').$destroy(true)});
                } catch(err) {
                    //OMGSCOTT call firebase for log
                }
                
                this.isSaving = false;
                this.$router.push('/apply')

            },
            pickedFontFamily(fontFamily) {
                // variable in pickedFontfamily is straight from font-picker.js
                // need to set it to this.fontFamily to use when rendering text as path
                
                this.fontFamily = fontFamily
                this.canvasObj.getActiveObject().set("fontFamily", this.fontFamily);
                this.canvasObj.renderAll();
                
            },
            removeTextShadow() { 
                this.textShadowDistance = 0;
                this.textShadowBlur = 0;
                this.textShadow360 = 0;

            },
            verticalAlign() {
                var activeObj = this.canvasObj.getActiveObject()
                activeObj.centerV()
            },
            horizontalAlign() {
                var activeObj = this.canvasObj.getActiveObject()
                activeObj.centerH()
            },
            toTop() {
                var activeObj = this.canvasObj.getActiveObject()
                activeObj.set('top', 0)
                activeObj.setCoords()
                this.canvasObj.renderAll();
            },
            toBottom() {
                var activeObj = this.canvasObj.getActiveObject()         
                let temp = this.canvasHeight - (activeObj.height * activeObj.scaleY) - 1
                activeObj.set('top', temp)
                activeObj.setCoords()
                this.canvasObj.renderAll();
            },       
            deleteItem() {
                let delObj = this.canvasObj.getActiveObject();
                if(delObj){
                    this.canvasObj.remove(delObj); 
                }
            },
            canvasBackgroundUrl(url) {
                // i tried to bind style to canvas element but too many things are accessing the style attribute
                if (url == 'checkered') {
                    // remove background image
                    document.getElementById("canvas").style.background = 'none';
                    document.getElementById("canvas").style.backgroundColor = '#eee';
                    document.getElementById("canvas").style.backgroundImage = 'linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02)),linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02))';
                    document.getElementById("canvas").style.backgroundSize = '30px 30px';
                    document.getElementById("canvas").style.backgroundPosition = '0 0,15px 15px';


                } else {
                    document.getElementById("canvas").style.background = url;
                    document.getElementById("canvas").style.backgroundRepeat = 'no-repeat';
                    document.getElementById("canvas").style.backgroundSize = '100%';                    
                }
            },
            addCopyright() {
                var activeObj = this.canvasObj.getActiveObject();
                if (activeObj.get('type') === "i-text") {
                    activeObj.insertChars('© ', null, 0);
                    this.canvasObj.renderAll();
                }
            },
            // Base64 File Upload Funtions (onFile, onLoad, onSizeExceeded)
            onFile: function onFile(file) { 
                this.uploadedWatermark.fileName = file.name
            },
            onLoad: function onLoad(dataUri) {
                this.uploadedWatermark.dataUri = dataUri

                var canvasScoped = this.canvasObj
                fabric.Image.fromURL(this.uploadedWatermark.dataUri, function(img) {
                    canvasScoped.add(img);
                    canvasScoped.bringToFront(img);
                });

                },
            onSizeExceeded: function onSizeExceeded(size) {
                alert('Image size exceeds limits of ' + this.customImageMaxSize + 'Mb!');
            },
            sidebarTypeChoosen: function(value) {
                var me;
                me = this;
                
                // this handles the back button (user leaving a page) with something done to canvas
                // value === '' means user clicked the back button on the sidebar template
                if (value === '' && this.canvasObj.getObjects().length !== 0) {
                    UIkit.modal.confirm('<i class="material-icons uk-inline" style="color: #f4c20d; font-size: 48px;">warning</i> Going back will cause any unsaved changes to be lost.')
                    .then(function () {
                        // set type to null, back to choose type
                        me.sidebarType = ''
                        me.canvasObj.clear()
                        me.aspectToggle('16_9')
                    }, function () {
                    });  
                } else if (value === 'full') {
                    // this makes sure if user clicks banner icons the activeObj will stay active
                    // if they're already on 'full' beceause aspectToggle removes active object
                    this.sidebarType = value
                } else {
                    this.sidebarType = value                
                    
                    if (this.sidebarType === 'border') {
                        this.aspectToggle('1_1')
                    } else {
                        this.aspectToggle('16_9')
                    }
                }


            },
            aspectToggle: function(aspectRatio) {
                var me;
                me = this;

                // remove any backgrounds samples user has selected
                this.canvasBackgroundUrl('checkered')

                let canvasScoped = this.canvasObj

                // #1) get current canvas json and dimensions
                let currentCanvasJson = this.canvasObj.toJSON()
                let currentCanvasWidth = document.getElementById('cwrap').offsetWidth
                let currentCanvasHeight = document.getElementById('cwrap').offsetHeight

                // #2) update css classes on id="cwrap"
                this.currentAspectRatio = aspectRatio;
                
                // #3) next tick waits for DOM updates (aspect ratio classes) to be added before canvas width is computed
                this.$nextTick(() => {
                    this.canvasWidth = document.getElementById('cwrap').offsetWidth
                    this.canvasHeight = document.getElementById('cwrap').offsetHeight

                    // resize canvas itself
                    this.canvasObj.setDimensions({
                        width: this.canvasWidth,
                        height: this.canvasHeight
                    })

                    // load JSON object with new canvas dimensions
                    if (this.watermarkType === 'full') {
                        fit(currentCanvasJson, currentCanvasWidth, currentCanvasHeight, this.canvasWidth, this.canvasHeight, 'json', null, null, function(result) {                        
                            me.canvasObj.loadFromJSON(result, canvasScoped.renderAll.bind(canvasScoped))
                        });
                    }
                    // this.canvasObj.loadFromJSON(newJson, canvasScoped.renderAll.bind(canvasScoped), function(o, object) {}); 
                    

                    this.canvasObj.renderAll();
                });
            },
            //
            // FUNCTIONS CALLED FROM SIDEBAR TYPES - FULL, TILED, BORDER, BADGE
            //

            // FULL
            addText() {
                // default font is Times New Roman
                let text = new fabric.IText('Double click to edit.', { 
                    left: 100, 
                    top: 100, 
                    originX: 'left',
                    originY: 'top',
                    fontFamily: 'Poppins'
                });

                text.setShadow('-1px 1px 3px #5b5b5b')
                text.set("strokeWidth", 0);
                text.set("fill", '#fff');
                
                this.canvasObj.add(text);
                
                text.setControlsVisibility({
                    mt: false,
                    mb: false,
                });
            }, 
            uploadMarkToCanvas: function(event) {
                var me
                me = this;
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // check for image upload size, prompt user if too big
                    if (input.files[0].size/1024 > 900) {
                        UIkit.modal.alert('<i class="material-icons uk-inline" style="color: #f4c20d; font-size: 48px;">warning</i> The logo or image you are uploading is too large. <hr>The max logo upload size is 1mb.<br><i>Your image size: <span style="color: red">' + Math.round(input.files[0].size/1024/1000) + 'mb</span> </i>')
                        return
                    }
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.dataUri = e.target.result;
                        
                        // Add uploaded image to canvas
                        let canvasScoped = this.canvasObj

                        fabric.Image.fromURL(this.dataUri, function(img) {
                            if (img.width > 400) {
                                var oImg = img
                                oImg.scaleToWidth(400);
                            } else {
                                var oImg = img
                            }
                            // oImg.set({centeredScaling: true})
                            canvasScoped.add(oImg);
                            canvasScoped.bringToFront(oImg);

                            // notify SVG is best
                            me.$notify({
                                group: 'loaded',
                                title: 'Helpful Tip:',
                                text: 'Using <b>SVG</b> will result in highest quality.',
                                type: 'info',
                                duration: 3000
                                // warn is just info :| sry lazy
                            });                             
                        });
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            },      
            applyTextEffect(shadowType) {
                var activeObj = this.canvasObj.getActiveObject() 
                
                if (shadowType === 'crisp') {
                    activeObj.setShadow('-1px 1px 3px #5b5b5b')
                    activeObj.set("strokeWidth", 0);
                    activeObj.set("fill", '#fff');
                } else if (shadowType === 'pop') {
                    activeObj.setShadow('-1px 1px 4px #808080')
                    activeObj.set("strokeWidth", 0);
                    activeObj.set("fill", 'black')
                } else if (shadowType === 'newspaper') {
                    activeObj.setShadow('0')
                    activeObj.set("stroke", '#383838');
                    activeObj.set("strokeWidth", 0.4);
                    activeObj.set("fill", '#fff');
                } else if (shadowType === 'vivid') {
                    activeObj.setShadow('0px 0px 4px #777')
                    activeObj.set("stroke", 'white');
                    activeObj.set("strokeWidth", 0.6);
                    activeObj.set("fill", 'black');
                } else if (shadowType === 'standard') {
                    activeObj.setShadow('0px 0px 0px #fff')
                    activeObj.set("strokeWidth", 0);
                }
            
                
                this.canvasObj.renderAll();
            },   
            addLogoFromSidebarFull(id) {
                var canvasScoped = this.canvasObj
                var elem = document.getElementById(id), svgStr = elem.innerHTML;
                
                fabric.loadSVGFromString(svgStr, function(objects, options) {
                    // Group elements to fabric.PathGroup (more than 1 elements) or
                    // to fabric.Path
                    var loadedObject = fabric.util.groupSVGElements(objects, options);

                    canvasScoped.add(loadedObject);
                    loadedObject.center().setCoords();

                    loadedObject.setControlsVisibility({
                        mt: false,
                        mb: false,
                        ml: false,
                        mr: false
                    });    
                       
                    canvasScoped.renderAll();
                });                         
            },      
            bringToFront() {
                var activeObj = this.canvasObj.getActiveObject()
                this.canvasObj.bringToFront(activeObj)
                this.canvasObj.renderAll();
            },
            sendToBack() {
                var activeObj = this.canvasObj.getActiveObject()
                this.canvasObj.sendToBack(activeObj)
                this.canvasObj.renderAll();

            },                                                      
            // TILED
            tileImage(userAddedImage) {
                // ps the fitters/tiledFit.js uses pretty much the same logic below
                // Add uploaded image to canvas
                var me;
                me = this;

                me.watermarkType = 'tiled' // using watermarkType and not sidebarType in case user is dumb and clicks out of sidenav before exporting
                me.markForTile = userAddedImage // this is used as baseImage in fitters/tiledFit.js

                let canvasScoped = this.canvasObj
                // clear canvas in case anything is on there :| b roofless and just take it away
                canvasScoped.clear();
        
                fabric.Image.fromURL(userAddedImage, function(img) {
                    
                    img.scaleToWidth(100);
                    me.patternSourceCanvas = new fabric.StaticCanvas();
                    me.patternSourceCanvas.add(img);
                    me.patternSourceCanvas.renderAll();
                    me.patternFabric = new fabric.Pattern({
                        source: function() {
                            me.patternSourceCanvas.setDimensions({
                                width: img.getScaledWidth() + me.patternPadding,
                                height: img.getScaledHeight() + me.patternPadding
                            });
                            me.patternSourceCanvas.renderAll();
                            return me.patternSourceCanvas.getElement();
                        },
                        repeat: 'repeat'
                    });

                    // run through and apply all settings to pattern canvas
                    var imgWidth = img.width * img.scaleX
                    var imgHeight = img.height * img.scaleY
                    img.set({originX: 'center',originY: 'center', left: imgWidth/2, top: imgHeight/2})
                    img.scaleToWidth(parseInt(me.patternScaleToWidth, 10))
                    img.set('angle', me.patternAngle);        
                    img.set("opacity", me.patternOpacity / 100);          
                    me.patternFabric.offsetX = parseInt(me.patternOffsetX, 10);
                    me.patternFabric.offsetY = parseInt(me.patternOffsetY, 10);

                    var rect = new fabric.Rect({
                        width: canvasScoped.width,
                        height: canvasScoped.height,
                        fill: me.patternFabric,
                        objectCaching: false,
                        selectable: false
                    });

                    canvasScoped.add(rect);
                    rect.center().setCoords();

                });
            },
            // BORDER

            /* THIS IS ATROCIOUS
            ... this currently works by setting a watcher on pretty much every prop in the sidebar tools
            and if it updates, it completely re-renders the canvas and applies changes... when the user saves
            it saves the props to a custom "border props blob" that gets loaded by fitBorder.js which then goes back 
            through almost identical logic again... super redundant and not very clean. I would suggest if i'm going
            to be lazy and re-render on all of these watches to just pass to fitBorder.js every time (as json output)
            so at least i only have border logic in one place */
            
            addBorder(type) {
                
                this.watermarkType = 'border'
                this.borderType = type;
                this.canvasObj.clear();

                if (type === null && !(this.borderTextTop || this.borderTextBottom)) {
                    return
                }

                // BORDER TOP   
                if (type === 'top') {
                    
                    var rect = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        originX: 'left',
                        originY: 'top',
                        selectable: false               
                    });
                    this.canvasObj.add(rect);     
                    

                    // visual helper to show where actual border will be placed
                    let strokeWidth = 2;
                    var userImagePlaceholderAnimation = new fabric.Rect({
                        width: this.canvasWidth - strokeWidth,
                        height: this.canvasHeight - rect.height - strokeWidth,
                        top: rect.height,
                        fill: 'rgba(0,0,0,0)',
                        stroke : '#11bb77',
                        strokeWidth : strokeWidth,
                        originX: 'left',
                        originY: 'top',
                        opacity: 1,
                        selectable: false               
                    });
                    this.canvasObj.add(userImagePlaceholderAnimation);       
                    
                    userImagePlaceholderAnimation.animate('opacity', '0', {
                        duration: 1300,
                        onChange: this.canvasObj.renderAll.bind(this.canvasObj),
                        onComplete: function() {
                            this.canvasObj.remove(userImagePlaceholderAnimation);
                        }
                    });   
                                                   

                }

                // BORDER TOP-INSET
                if (type === 'top-inset') {
                    var rect = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        opacity: this.borderOpacitySlider/100,
                        originX: 'left',
                        originY: 'top',
                        selectable: false               
                    });
                    this.canvasObj.add(rect);                      

                    // visual helper to show where border will actually be placed
                    let strokeWidth = 2;
                    var userImagePlaceholderAnimation = new fabric.Rect({
                        id: 'userImagePlaceholderAnimation',
                        width: this.canvasWidth - strokeWidth,
                        height: this.canvasHeight - strokeWidth,
                        fill: 'rgba(0,0,0,0)',
                        stroke : '#11bb77',
                        strokeWidth : strokeWidth,
                        originX: 'left',
                        originY: 'top',
                        opacity: 1,
                        selectable: false               
                    });
                    this.canvasObj.add(userImagePlaceholderAnimation);       
                    
                    userImagePlaceholderAnimation.animate('opacity', '0', {
                        duration: 1300,
                        onChange: this.canvasObj.renderAll.bind(this.canvasObj),
                        onComplete: function() {
                            this.canvasObj.remove(userImagePlaceholderAnimation);
                        }
                    });  
                }
                // BORDER BOTTOM
                if (type === 'bottom') {
                    // add rect
                    var rect = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        selectable: false          
                    });

                    let temp = this.canvasHeight - (rect.height * rect.scaleY) - 1
                    rect.set('top', temp)
                    rect.setCoords()                
                    this.canvasObj.add(rect);  

                    
                    // visual helper to show wehre actual border will be placed
                    let strokeWidth = 2;
                    var userImagePlaceholderAnimation = new fabric.Rect({
                        width: this.canvasWidth - strokeWidth,
                        height: this.canvasHeight - rect.height - strokeWidth,
                        fill: 'rgba(0,0,0,0)',
                        stroke : '#11bb77',
                        strokeWidth : strokeWidth,
                        originX: 'left',
                        originY: 'top',
                        opacity: 1,
                        selectable: false               
                    });
                    this.canvasObj.add(userImagePlaceholderAnimation);       
                    
                    userImagePlaceholderAnimation.animate('opacity', '0', {
                        duration: 1300,
                        onChange: this.canvasObj.renderAll.bind(this.canvasObj),
                        onComplete: function() {
                            this.canvasObj.remove(userImagePlaceholderAnimation);
                        }
                    });                       

                }                
                // BORDER BOTTOM-INSET
                if (type === 'bottom-inset') {
                    var rect = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        opacity: this.borderOpacitySlider/100,
                        originX: 'left',
                        originY: 'top',
                        selectable: false               
                    });


                    let temp = this.canvasHeight - (rect.height * rect.scaleY) - 1
                    rect.set('top', temp)
                    rect.setCoords()                         
                    this.canvasObj.add(rect); 

                    // visual helper to show where border will actually be placed
                    let strokeWidth = 2;
                    var userImagePlaceholderAnimation = new fabric.Rect({
                        width: this.canvasWidth - strokeWidth,
                        height: this.canvasHeight - strokeWidth,
                        fill: 'rgba(0,0,0,0)',
                        stroke : '#11bb77',
                        strokeWidth : strokeWidth,
                        originX: 'left',
                        originY: 'top',
                        opacity: 1,
                        selectable: false               
                    });
                    this.canvasObj.add(userImagePlaceholderAnimation);       
                    
                    userImagePlaceholderAnimation.animate('opacity', '0', {
                        duration: 1300,
                        onChange: this.canvasObj.renderAll.bind(this.canvasObj),
                        onComplete: function() {
                            this.canvasObj.remove(userImagePlaceholderAnimation);
                        }
                    });                     
                }                
                // BORDER ALL-SIDES
                if (type === 'all-sides') {
                    // top
                    var rectTop = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        opacity: this.borderOpacitySlider,
                        originX: 'left',
                        originY: 'top',
                        selectable: false               
                    });

                    this.canvasObj.add(rectTop);                  
                    // bottom
                    var rectBottom = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        selectable: false          
                    });

                    let temp = this.canvasHeight - (rectBottom.height * rectBottom.scaleY) - 1
                    rectBottom.set('top', temp)
                    rectBottom.setCoords()                                
                    this.canvasObj.add(rectBottom);                           
                    // left
                    var rectLeft = new fabric.Rect({
                        width: rectTop.height,
                        height: this.canvasHeight,
                        fill: this.borderColor.hex,
                        selectable: false          
                    });
                            
                    this.canvasObj.add(rectLeft);                              
                    // right
                    var rectRight = new fabric.Rect({
                        width: rectTop.height,
                        height: this.canvasHeight,
                        left: this.canvasWidth - rectTop.height,
                        fill: this.borderColor.hex,
                        selectable: false          
                    });
                    this.canvasObj.add(rectRight);                        

                    // visual helper to show where border will actually be placed
                    let strokeWidth = 2;
                    var userImagePlaceholderAnimation = new fabric.Rect({
                        width: this.canvasWidth - (2* rectTop.height) - strokeWidth,
                        height: this.canvasHeight - (2* rectTop.height) - strokeWidth,
                        fill: 'rgba(0,0,0,0)',
                        stroke : '#11bb77',
                        strokeWidth : strokeWidth,
                        originX: 'left',
                        originY: 'top',
                        opacity: 1,
                        selectable: false               
                    });
                    
                    this.canvasObj.add(userImagePlaceholderAnimation);       
                    userImagePlaceholderAnimation.center()
                    userImagePlaceholderAnimation.animate('opacity', '0', {
                        duration: 1300,
                        onChange: this.canvasObj.renderAll.bind(this.canvasObj),
                        onComplete: function() {
                            this.canvasObj.remove(userImagePlaceholderAnimation);
                        }
                    });                           

                }                
                // BORDER MEME
                if (type === 'meme') {
                    // border top
                    var rect = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        opacity: this.borderOpacitySlider/100,
                        selectable: false               
                    });

                    this.canvasObj.add(rect);   

                    // add rect bottom
                    var rect2 = new fabric.Rect({
                        width: this.canvasWidth,
                        height: this.borderSize(),
                        fill: this.borderColor.hex,
                        opacity: this.borderOpacitySlider/100,
                        selectable: false          
                    });

                    let temp = this.canvasHeight - (rect2.height * rect2.scaleY) - 1
                    rect2.set('top', temp)
                    rect2.setCoords()                                
                    this.canvasObj.add(rect2);  

                    // visual helper to show where border will actually be placed
                    let strokeWidth = 2;
                    var userImagePlaceholderAnimation = new fabric.Rect({
                        width: this.canvasWidth - strokeWidth,
                        height: this.canvasHeight - strokeWidth,
                        fill: 'rgba(0,0,0,0)',
                        stroke : '#11bb77',
                        strokeWidth : strokeWidth,
                        originX: 'left',
                        originY: 'top',
                        opacity: 1,
                        selectable: false               
                    });
                    this.canvasObj.add(userImagePlaceholderAnimation);       
                    
                    userImagePlaceholderAnimation.animate('opacity', '0', {
                        duration: 1300,
                        onChange: this.canvasObj.renderAll.bind(this.canvasObj),
                        onComplete: function() {
                            this.canvasObj.remove(userImagePlaceholderAnimation);
                        }
                    });                     
                }   
                
                //
                // TEXT
                //

                if (this.borderTextTop) {
                    var text = new fabric.IText(this.borderTextTop, {
                        fontSize: this.borderFontSizeSlider.value,
                        fontFamily: this.fontFamily,
                        fill: this.colorFill.hex || 'black',
                        stroke: this.colorBorder.hex,
                        strokeWidth: this.borderWidth,    
                        left: 0,
                        top: 100,                            
                        editable: false,                       
                        lockMovementX: true,
                        lockMovementY: true,
                        lockScalingX: true,
                        lockScalingY: true,
                        lockUniScaling: true,
                        lockRotation: true
                    });     
                    
                    // set height to middle of rectangle
                    text.set('top', (this.borderSize() - text.height)/2)
                    this.canvasObj.add(text);   
                    // set left / center / right
                    if (this.borderTextPosition === 'left') {
                        // nothing
                    } else if (this.borderTextPosition === 'center') {
                        text.centerH()                            
                    } else if (this.borderTextPosition === 'right') {
                        text.set('left', this.canvasWidth - text.width - 0.01)
                    }        
                    text.setCoords()                                
                }  

                if (this.borderTextBottom) {
                    var text = new fabric.IText(this.borderTextBottom, {
                        fontSize: this.borderFontSizeSlider.value,
                        fontFamily: this.fontFamily,
                        fill: this.colorFill.hex || 'black',
                        stroke: this.colorBorder.hex,
                        strokeWidth: this.borderWidth,                             
                        left: 0,
                        top: 100,                            
                        editable: false,                       
                        lockMovementX: true,
                        lockMovementY: true,
                        lockScalingX: true,
                        lockScalingY: true,
                        lockUniScaling: true,
                        lockRotation: true
                    });     
                    
                    // set height to middle of rectangle
                    text.set('top', (this.canvasHeight - this.borderSize()) + (this.borderSize() - text.height)/2)
                    this.canvasObj.add(text);   
                    // set left / center / right
                    if (this.borderTextPosition === 'left') {
                        // nothing
                    } else if (this.borderTextPosition === 'center') {
                        text.centerH()                            
                    } else if (this.borderTextPosition === 'right') {
                        text.set('left', this.canvasWidth - text.width)
                    }
                    text.setCoords()                                     
                }  

                this.canvasObj.requestRenderAll();  

            },
            borderSize: function () {
                var size;
                // border size converts the "XS, S, M, L, etc" values to numerical so you can use it as a multiplier
                // you have to select first .value because i setup a piecewise for aesthetics
                if (this.borderSizeSlider.value[0] === 'XS') {
                    size = this.canvasHeight * 0.033
                } else if (this.borderSizeSlider.value[0] === 'XS') {
                    size = this.canvasHeight * 0.066
                } else if (this.borderSizeSlider.value[0] === 'S') {
                    size = this.canvasHeight * 0.1
                } else if (this.borderSizeSlider.value[0] === 'M') {
                    size = this.canvasHeight * 0.133
                } else if (this.borderSizeSlider.value[0] === 'L') {
                    size = this.canvasHeight * 0.166
                } else if (this.borderSizeSlider.value[0] === 'XL') {
                    size = this.canvasHeight * 0.2
                }
                return size
            },             
            // BADGE            
        },
        created() {        
        },
        watch: {         
            // Canvas Object Modifications
            // object fill color
            'colorFill': function() {
                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.set("fill", this.colorFill.hex);
                    activeObj.set("opacity", this.colorFill.a);                 
                    this.canvasObj.renderAll();
                }
            },
            // object border color
            'colorBorder': function() {
                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.set("stroke", this.colorBorder.hex);
                    activeObj.set("opacity", this.colorBorder.a);                 
                    this.canvasObj.renderAll();
                }
            },
            // border width
            'borderWidth': function() {
                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.set("stroke", this.colorBorder.hex);
                    activeObj.set("strokeWidth", this.borderWidth);               
                    this.canvasObj.renderAll();
                }
            },
            // text shadow
            'textShadow360': function() {      
                // the circle slider is 0-360 with step of 1. needs to convert to radians and "rotated" 90degs since 
                // 0degs is at bottom (pointing south)
                if (this.textShadow360 >= 0 && this.textShadow360 < 180) {
                    this.textShadow.offsetX = -Math.sin(toRadians(this.textShadow360)) * this.textShadowDistance;
                    this.textShadow.offsetY = Math.cos(toRadians(this.textShadow360)) * this.textShadowDistance;
                } else {
                    this.textShadow.offsetX = -Math.sin(toRadians(this.textShadow360)) * this.textShadowDistance;
                    this.textShadow.offsetY = Math.cos(toRadians(this.textShadow360)) * this.textShadowDistance;
                }

                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.setShadow(this.textShadow)
                    this.canvasObj.renderAll();
                }            

                // set textShadowString for preview
                this.textShadowString = this.textShadow.offsetX.toFixed(2) + 'px ' + this.textShadow.offsetY.toFixed(2) + 'px ' + this.textShadow.blur + 'px ' + this.textShadow.color

            },
            // text shadow distance
            'textShadowDistance': function() {
                // i had to repeat this so that the shadow preview is controlled synchronously if circle slider or distance is used :|
                if (this.textShadow360 >= 0 && this.textShadow360 < 180) {
                    this.textShadow.offsetX = -Math.sin(toRadians(this.textShadow360)) * this.textShadowDistance;
                    this.textShadow.offsetY = Math.cos(toRadians(this.textShadow360)) * this.textShadowDistance;
                } else {
                    this.textShadow.offsetX = -Math.sin(toRadians(this.textShadow360)) * this.textShadowDistance;
                    this.textShadow.offsetY = Math.cos(toRadians(this.textShadow360)) * this.textShadowDistance;
                }

                // set textShadowString for preview
                this.textShadowString = this.textShadow.offsetX.toFixed(2) + 'px ' + this.textShadow.offsetY.toFixed(2) + 'px ' + this.textShadow.blur + 'px ' + this.textShadow.color

                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.setShadow(this.textShadow)
                    this.canvasObj.renderAll();
                }            
            },
            'textShadowBlur': function() {
                // set textShadowString for preview
                this.textShadow.blur = this.textShadowBlur

                this.textShadowString = this.textShadow.offsetX.toFixed(2) + 'px ' + this.textShadow.offsetY.toFixed(2) + 'px ' + this.textShadow.blur + 'px ' + this.textShadow.color

                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.setShadow(this.textShadow)
                    this.canvasObj.renderAll();
                }
            },
            'textShadowColor': function() {
                // set textShadowString for preview
                this.textShadow.color = this.textShadowColor.hex;

                this.textShadowString = this.textShadow.offsetX.toFixed(2) + 'px ' + this.textShadow.offsetY.toFixed(2) + 'px ' + this.textShadow.blur + 'px ' + this.textShadow.color

                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.setShadow(this.textShadow)
                    this.canvasObj.renderAll();
                }
            },
            // image opacity
            'opacityVueSlider': function() {
                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.set("opacity", this.opacityVueSlider / 100);  
                    this.canvasObj.renderAll();
                }
            },
            // textbox opacity
            'opacityVueSliderText': function() {
                var activeObj = this.canvasObj.getActiveObject()
                if (activeObj != null) {
                    activeObj.set("opacity", this.opacityVueSliderText / 100);  
                    this.canvasObj.renderAll();
                }
            },             
            // pattern scale
            'patternScaleToWidth': function() {
                // me.patternSourceCanvas already made when user added image
                // need to access Fabric.Image object loaded to that canvas to apply scaling changes
                if (this.patternSourceCanvas) {
                    // annoyingly ... i need to check set the origin to center of the patternSourceCanvas so it will rotate in center
                    // this needs to acccount for both scale and reposition each time something changes
                    var img = this.patternSourceCanvas.getObjects()[0] // image
                    var imgWidth = img.width * img.scaleX
                    var imgHeight = img.height * img.scaleY
                    img.set({originX: 'center',originY: 'center', left: imgWidth/2, top: imgHeight/2})  

                    img.scaleToWidth(parseInt(this.patternScaleToWidth, 10))             
                    this.canvasObj.requestRenderAll();    
                }
                
            },
            // pattern padding         
            'patternPadding': function() {
                // padding is already registered with patternFabric object
                if (this.patternSourceCanvas) {
                    var img = this.patternSourceCanvas.getObjects()[0] // image
                    var imgWidth = img.width * img.scaleX
                    var imgHeight = img.height * img.scaleY
                    img.set({originX: 'center',originY: 'center', left: imgWidth/2, top: imgHeight/2})                 
                    
                    this.canvasObj.requestRenderAll();
                }
            },    
            // pattern offset x
            'patternOffsetX': function() {
                // patternFabric object (which is _the_ pattern object, has an offset method that needs to be applied)
                if (this.patternSourceCanvas) {
                    this.patternFabric.offsetX = this.patternOffsetX
                    this.canvasObj.requestRenderAll();
                }
            },      
            // pattern offset y        
            'patternOffsetY': function() {
                // patternFabric object (which is _the_ pattern object, has an offset method that needs to be applied)
                if (this.patternSourceCanvas) {
                    this.patternFabric.offsetY = this.patternOffsetY
                    this.canvasObj.requestRenderAll();
                }
            },   
            // pattern angle            
            'patternAngle': function() {
                // me.patternSourceCanvas already made when user added image
                // need to access Fabric.Image object loaded to that canvas to apply scaling changes                
                if (this.patternSourceCanvas) {
                    var img = this.patternSourceCanvas.getObjects()[0] // image
                    img.set('angle', this.patternAngle)             
                    this.canvasObj.requestRenderAll();    
                }
            },  
            // pattern opacity
            'patternOpacity': function() {
                // me.patternSourceCanvas already made when user added image
                // need to access Fabric.Image object loaded to that canvas to apply scaling changes                
                if (this.patternSourceCanvas) {
                    var img = this.patternSourceCanvas.getObjects()[0] // image
                    img.set("opacity", this.patternOpacity / 100);  
                    this.canvasObj.requestRenderAll();   
                }
            },  
            // border color
            'borderColor.hex': function() {    
                var me;
                me = this;
                this.canvasObj.getObjects().filter(function(o) {
                    if (o.get('type') === 'rect') {
                        return o.set('fill', me.borderColor.hex);
                    }
                });    
                this.canvasObj.requestRenderAll();            
            },   
            'borderOpacitySlider': function() {
                this.addBorder(this.borderType);
            },
            // border size
            'borderSizeSlider.value': function() {  
                // on border resize.. the "addBorder()" func is called which deletes
                // and re-adds the border with the newly selected value   
                this.addBorder(this.borderType)
            },        
            // border font size
            'borderFontSizeSlider.value': function() {  
                // on border resize.. the "addBorder()" func is called which deletes
                // and re-adds the border with the newly selected value   
                this.addBorder(this.borderType)
            },       
            // border add text top
            'borderTextTop': function() {
                this.addBorder(this.borderType)
            },
            // border add text bottom
            'borderTextBottom': function() {
                this.addBorder(this.borderType)
            },
            'borderTextPosition': function() {
                this.addBorder(this.borderType)
            }         
        }
    }

</script>

<style scoped>

    /*
    aspect ratio  |  multiply width by
    -----------------------------------
        1:1      |         1
        1:3      |         3
        4:3      |        0.75
        4:5      |        0.8
        16:9     |       0.5625
    */
    .cwrap_16_9 { /* 36/64 */
        height: 31.5vw;
        width: 56vw;  
        margin: 5vmin auto;
        margin-top: 6px;
    }

    .cwrap_4_5 {
        height: 70vh;
        width: 56vh;
        margin: 5vmin auto;
        margin-top: 6px;
    }

    .cwrap_1_1 {
        height: 64vh;
        width: 64vh;
        margin: 5vmin auto;
        margin-top: 6px;
    }        

    #canvas { display:block; } /* To remove the scrollbars */

    .text-tools {
        position: absolute;
        margin-top: -55.6px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        height: 55.6px;
        width: 590px;
        padding-left: 10px;
        padding-right: 5px;
        background: #f8f8f8;
        border: 1px #39f solid;
        z-index: 33;
    }

    .divider-text-tools {
        height: 2em;
        margin-top: 12px;
        margin-bottom: 10px;
        margin-left: 10px;
        margin-right: 10px;
        border-left: 1px solid #c4c4c4;
    }
    .image-tools {
        position: absolute;
        margin-top: -55.6px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;       
        height: 55.6px;
        width: 290px;
        background: #f8f8f8;
        border: 1px #39f solid;
    }

    div[id^="font-picker"] {
        position: relative;
        display: inline-block;
        width: 200px;
        padding: 10px 0 0 15px;
        box-shadow: 0 0 0 0 !important;
    }
    
    .design-body {
        padding-left: 220px;
        overflow-x: auto;
    }

    .design-body .uk-button {
        border-radius: 2px;
    }

    .body-navbar {
        background: #F5F5F5 !important;
        box-shadow: 0 2px 2px -1px rgba(0,0,0,0.16) !important;      
    }

    .canvasexy {
        border: 1px #A0A0A0 solid;
        border-radius: 2px;
        box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.14), 0 1px 5px 0 rgba(150, 150, 150, 0.14);
    }

    .checkered {
        background-color: #eee;
        background-image: linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02)),linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02));
        background-size: 30px 30px;
        background-position: 0 0,15px 15px;
    }

    .iconspace {
        padding-left: 10px;
        padding-right: 10px;     
    }

    .divider {
        height: 1.75em;
        margin-top: 10px;
        margin-bottom: 10px;
        margin-left: 10px;
        margin-right: 10px;
        border-left: 1px solid #c4c4c4;
    }

    .uk-link-text {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .scroller::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    .scroller::-webkit-scrollbar-track {
        opacity: 0;
    }
    .scroller::-webkit-scrollbar-thumb {
        background: rgba(139, 139, 139, 0.466);
        visibility:hidden;
        border-radius: 5px;
    }
    .scroller::-webkit-scrollbar-thumb {
        visibility:visible;
    }

    .aspect_ratios {
        padding-top: 5px;
    }
    .aspect_ratios:hover {
        color: #666;    
    }
    
    .text-controls {
        padding-top: 10px;
    }

    .object-edit-card {
        margin-top: 10px;
        position: relative;
        width: 200px;
        padding: 10px;
        box-sizing: initial;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15);
    }

    .object-edit-card-2 {
        margin-top: -10px;
        margin-left: -5px;
        width: 300px;
        padding: 10px 20px 15px 20px;
        box-sizing: initial;
        background: #f8f8f8;
        border-radius: 4px;
        box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.5);
    }

    .apply-font {
        background: #ffc600;
    }

    .checkered-small {
        background-color: rgb(238, 238, 238);
        background-image: linear-gradient(45deg,rgba(0,0,0,.15) 25%,transparent 0,transparent 75%,rgba(0,0,0,.15) 0,rgba(0,0,0,.15)),linear-gradient(45deg,rgba(0,0,0,.15) 25%,transparent 0,transparent 75%,rgba(0,0,0,.15) 0,rgba(0,0,0,.15));
        background-size: 20px 20px;
        background-position: 0 0,10px 10px;
        border-radius: 7px;
    }

    .canvas-background-selector {
        position: relative;
        float: right;
        margin-top: -42px;
        height: 60x;
        width: 125px;
        border-radius: 2px;
    }

    .uk-icon-image {
        width: 23px;
        height: 23px;
    }

    input[type="file"] {
        display: none;
    }

    label {
        cursor: pointer;
    }

    .vc-grayscale {
        width: 250px;
        margin: auto;
    }

    .highlight-red {
        transition: border 0.4s ease !important;
        border: 1px solid #F24C4E !important;
    }

    /* Input Slider Style (so much space :|) */
    input[type=range] {
    height: 0;
    -webkit-appearance: none;
    margin: 10px 0;
    width: 100%;
    background-color: rgba(100, 100, 100, 0) !important;
    }
    input[type=range]:focus {
    outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    box-shadow: 0px 0px 1px #000000;
    background-image: linear-gradient(90deg, rgba(2, 0, 36, 0) 0%, rgb(134, 134, 134) 100%);
    border-radius: 1px;
    border: 0px solid #010101;
    }
    input[type=range]::-webkit-slider-thumb {
    box-shadow: 0px 0px 1px #000031;
    border: 1px solid #00001E;
    height: 16px;
    width: 16px;
    border-radius: 15px;
    background: #FFFFFF;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -5.5px;
    }
    input[type=range]:focus::-webkit-slider-runnable-track {
    background-image: linear-gradient(90deg, rgba(2, 0, 36, 0) 0%, rgb(134, 134, 134) 100%);
    }
    input[type=range]::-moz-range-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    box-shadow: 0px 0px 1px #000000;
    background-image: linear-gradient(90deg, rgba(2, 0, 36, 0) 0%, rgb(134, 134, 134) 100%);
    border-radius: 1px;
    border: 0px solid #010101;
    }
    input[type=range]::-moz-range-thumb {
    box-shadow: 0px 0px 1px #000031;
    border: 1px solid #00001E;
    height: 16px;
    width: 16px;
    border-radius: 15px;
    background: #FFFFFF;
    cursor: pointer;
    }
    input[type=range]::-ms-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
    }
    input[type=range]::-ms-fill-lower {
    background: #D8D8D8;
    border: 0px solid #010101;
    border-radius: 2px;
    box-shadow: 0px 0px 1px #000000;
    }
    input[type=range]::-ms-fill-upper {
    background: #D8D8D8;
    border: 0px solid #010101;
    border-radius: 2px;
    box-shadow: 0px 0px 1px #000000;
    }
    input[type=range]::-ms-thumb {
    margin-top: 1px;
    box-shadow: 0px 0px 1px #000031;
    border: 1px solid #00001E;
    height: 16px;
    width: 16px;
    border-radius: 15px;
    background: #FFFFFF;
    cursor: pointer;
    }
    input[type=range]:focus::-ms-fill-lower {
    background: rgba(216, 216, 216, 0);
    }
    input[type=range]:focus::-ms-fill-upper {
    background: rgba(216, 216, 216, 0);
    }

</style>